import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth'

interface AdminAccessUser {
  id: string
  name: string
  phone: string
  role: 'owner' | 'manager'
  tenantId: string
}

export default function AdminAccessPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setAuth, logout } = useAuthStore()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const token = searchParams.get('token')
    const userRaw = searchParams.get('user')

    if (!token || !userRaw) {
      setError('Недействительная ссылка')
      return
    }

    try {
      const user: AdminAccessUser = JSON.parse(decodeURIComponent(atob(userRaw)))
      if (!user.id || !user.role || !user.tenantId) throw new Error('bad user')

      // Clear any existing session first, then set the admin-provided one
      logout()
      setAuth(user, token)

      const dest = user.role === 'owner' ? '/owner' : '/manager'
      navigate(dest, { replace: true })
    } catch {
      setError('Ошибка при входе — токен недействителен или истёк')
    }
  }, [])

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white border border-red-200 rounded-2xl p-6 max-w-sm w-full text-center space-y-3">
          <div className="text-3xl">⚠️</div>
          <p className="text-sm font-medium text-red-700">{error}</p>
          <button
            onClick={() => navigate('/admin', { replace: true })}
            className="text-xs text-gray-500 hover:text-gray-700 underline"
          >
            Вернуться в Admin Panel
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center space-y-2">
        <div className="text-3xl animate-pulse">🔑</div>
        <p className="text-sm text-gray-500">Вход как владелец...</p>
      </div>
    </div>
  )
}
